export const companyName = 'проектного финансирование';